<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">無料トライアルの申し込み</span>
              <span class="breadcrumb-link">無料トライアルの登録</span>
              <span class="breadcrumb-link">無料トライアルの登録の確認</span>
              <span class="breadcrumb-link current">無料トライアルの登録の完了</span>
            </div>
            <h1 class="hdg02">無料トライアルの登録の完了</h1>
          </div>
          <div class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">無料トライアル登録が完了しました。ご登録のアドレスに仮パスワードをお送りしました。ログイン画面から、ご登録いただいたメールアドレスと、メールに記載されている仮パスワードでログインしてください。</p>
              
              <div class="contact-submit mb40">
                <div class="button contact-submit-button">
                  <router-link class="btn" to="/pc/login">ログイン画面へ</router-link>
                </div>
              </div>

              <div class="contact-content-info">
                <table class="contact-content-info-table">
                  <colgroup>
                    <col style="width:100px;">
                    <col style="width:200px;">
                  </colgroup>
                  <tr>
                    <th>申込内容</th>
                    <td>無料トライアルの申込</td>
                  </tr>
                  <tr>
                    <th>申込日</th>
                    <td>{{ group1.createdDisp }}</td>
                  </tr>
                </table>
                <div class="contact-content-info-number">申込No.{{ group1.applicationNo }}</div>
              </div>

              <!-- PCの場合 -->
              <div class="visible-pc">
                <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" class="tbl04 box-package">
                  <div class="tbl04-hdgarea">
                    <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                    <p class="txt mb0">お申し込みいただいたライセンスは、本日から{{ item.period_end }} までご利用いただけます。</p>
                  </div>
                  <div class="tbl04-bodyarea">
                    <table class="tbl04-table">
                      <colgroup>
                        <col style="width:40%;">
                        <col sytle="width:20%;">
                        <col sytle="width:20%;">
                        <col sytle="width:20%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th></th>
                          <th>申込ライセンス数</th>
                          <th>ライセンス期限</th>
                          <th>価格（税込）</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                          <th>
                            <div class="tbl04-table-txt">{{ item2.name }}</div>
                          </th>
                          <td>
                            <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                          </td>
                          <td>
                            <div class="tbl04-table-txt">{{ item2.period_expression }}</div>
                            <div class="tbl04-table-txt-sub">（{{ item2.period_start }} ~ {{ item2.period_end }}）</div>
                          </td>
                          <td>
                            <div class="tbl04-table-txt">無料</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- SPの場合 -->
              <div class="visible-sp">
                <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" class="tbl04">
                  <div class="tbl04-hdgarea">
                    <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                    <p class="txt mb0">お申し込みいただいたライセンスは、本日から{{ item.period_end }} までご利用いただけます。</p>
                  </div>
                  <div class="tbl04-bodyarea">
                    <table class="tbl04-table">
                      <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                        <td>
                          <div class="tbl04-table-txt">{{ item2.name }}</div>
                        </td>
                        <th>申込ライセンス数</th>
                        <td>
                          <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                        </td>
                        <th>ライセンス期限</th>
                        <td>
                          <div class="tbl04-table-txt">{{ item2.period_expression }}</div>
                          <div class="tbl04-table-txt-sub">（{{ item2.period_start }} ~ {{ item2.period_end }}）</div>
                        </td>
                        <th>価格（税込）</th>
                        <td>
                          <div class="tbl04-table-txt">無料</div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'
import * as logicTrialRegistration from '@/logic/public/TrialRegistration'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicTrialRegistration.getGroupComplete()

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>

</style>
